import { useState } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import { Button } from '@usacow/ds';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';

const GoogleMark = () => (
  <svg width="17" height="17" viewBox="0 0 18 18" aria-hidden="true">
    <path
      fill="#4285F4"
      d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.71-1.57 2.68-3.89 2.68-6.62Z"
    />
    <path
      fill="#34A853"
      d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.81.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18Z"
    />
    <path fill="#FBBC05" d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33Z" />
    <path
      fill="#EA4335"
      d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58Z"
    />
  </svg>
);

const ERRORS: Record<string, string> = {
  bad_state: 'Your sign-in session expired. Try again.',
  exchange_failed: "Couldn't complete sign-in with Google. Try again.",
  missing_code: 'Sign-in was cancelled.',
};

export function Auth() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [attested, setAttested] = useState(false);
  const error = params.get('error');
  const redirect = params.get('redirect') ?? '/app';

  async function devLogin() {
    const { isNew } = await api.devLogin();
    await refresh();
    navigate(isNew ? '/onboarding' : redirect);
  }

  return (
    <div className="auth">
      <div className="auth-card">
        <img src="/logo-mark.svg" width={40} height={40} alt="" style={{ marginBottom: 16 }} />
        <h1 className="auth-h">Sign in to usaCow</h1>
        <p className="auth-sub">Free, no card. Start with the diagnostic.</p>

        {error && (
          <div className="auth-error" role="alert">
            {ERRORS[error] ?? 'Something went wrong. Try again.'}
          </div>
        )}

        <label className="auth-attest">
          <input
            type="checkbox"
            checked={attested}
            onChange={(e) => setAttested(e.target.checked)}
          />
          <span>
            I&apos;m 13 or older and agree to the <Link to="/privacy">privacy policy</Link>.
          </span>
        </label>

        <Button
          variant="primary"
          size="lg"
          style={{ width: '100%' }}
          disabled={!attested}
          leftIcon={<GoogleMark />}
          onClick={() => api.signInWithGoogle(redirect)}
        >
          Continue with Google
        </Button>

        <p className="auth-fine">
          We only read your name and email to create your account. No data is sold.
        </p>

        {import.meta.env.DEV && (
          <button className="auth-dev" onClick={devLogin}>
            Dev login (local only)
          </button>
        )}
      </div>
    </div>
  );
}
